import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { uploadBytes, getStorage, ref, getDownloadURL, getBlob, listAll } from "firebase/storage";
import { storage } from "./utilities/firebase";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { count } from "random-words";
import NewBlacklist from "./blacklist-form/new-blacklist";
import Blacklist from "./features/blacklist/blacklist";
import NotUser from "./utilities/not-user";
import NotPaid from "./utilities/not-paid";

const MainPage = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [showComplaint, setShowComplaint] = useState(false);
    const [isVisible, setIsVisible] = useState(false)


    const [blacklist, setBlacklist] = useState([]);
    const [showBlacklist, setShowBlacklist] = useState(true)
    
    
    let count = 0;

    const today = new Date();

    const checkPaid = async () => {
        await axios.post('')
    }

    useEffect(() => {
        setIsVisible(true)
    }, [])

    const navigate = useNavigate();

    const company = Cookies.get(`token_company`);
    const email = Cookies.get(`token_email`);
    const firstname = Cookies.get(`token_first_name`);
    const lastname = Cookies.get(`token_last_name`);
    const phone = Cookies.get(`token_phone`);


    if (!firstname || !lastname || !company || !email || !phone) {
        return (
                <NotUser/>
        )
    }

    const status = Cookies.get(`token_status`);


    if (status != 'Paid') {
        return (
            <NotPaid/>
        )
    }
    
    return ( 
        <div>
            <div>
                <h1 className={` display-6 text-muted text-center  `}>Welcome {firstname} </h1>

            </div>
            <div className="container d-flex justify-content-center mt-3">
                <button className="btn btn-outline-primary btn-lg" onClick={() => {
                    if (showComplaint) {
                        setShowComplaint(false)
                        setShowBlacklist(true)
                    } else {
                        setShowComplaint(true)
                        setShowBlacklist(false)
                    }
                }}>List Bad Apple</button>
            </div >
            {
                showComplaint &&
                <NewBlacklist setShowComplaint={setShowComplaint} setShowBlacklist={setShowBlacklist}/>
            }
          <div className="d-flex flex-column justify-content-center">
            {showBlacklist &&
                <Blacklist/>
            }
          </div>
        </div>
     );
}
 
export default MainPage;